import dynamic from "next/dynamic";

export const DynamicPlusArticlePopup = dynamic(() =>
  import(".").then(module => module.PlusArticlePopup),
);
